import {makeStyles, Typography} from "@material-ui/core";
import React from "react";
import {Grid} from "@material-ui/core";

const useInfoStyles = makeStyles(theme => ({
    root: {
        padding: '2%',
        whiteSpace: 'initial',
        display: 'inline-block',
        width: '100%',
        '& table tr td': {
            border: '1px solid #fff'
        },
        '& a': {
            color: '#fff'
        }
    }
}))
const PagePoliticaDeConfidentialitate = () => {

    const classes = useInfoStyles();

    return <Grid item xs={12} className={classes.root}>
        <Typography variant="body2" color={"textSecondary"} display={"block"} component="div">
            <div className="sd-section">
                <div className="page-text">

                    <div className="fusion-text">
                        <h3 className="text-center">Declarație privind confidențialitatea</h3>
                    </div>
                    <div className="fusion-text"><h3>Introducere</h3>
                        <p>Danone știe că sunteți interesați de modul în care datele dumneavoastră cu caracter personal sunt
                            utilizate,
                            recunoscând, în același timp, importanța protecției confidențialității.</p>
                        <p>Declarația privind confidențialitatea vă explică modul în care Danone S.A. și toate filialele
                            sale (“Danone”)
                            colectează și gestionează datele dumneavoastră cu caracter personal. Aceasta conține informații
                            despre
                            datele pe care le colectăm, despre modul în care le utilizăm, justificarea și beneficiile pentru
                            dumneavoastră.</p>
                        <p>Vă rugăm să ne contactați la adresa de email&nbsp;<a
                            href="mailto:callcenter@mediasat.ro">callcenter@mediasat.ro</a>&nbsp;în
                            cazul în care aveți întrebări sau observații, sau în care doriți să ne transmiteți o solicitare
                            referitoare
                            la oricare dintre drepturile dumneavoastră în calitate de persoană vizată.</p>
                        <p>Prezenta declarație privind confidențialitatea a fost actualizată cel mai recent la data de
                            06.10.2017</p>
                        <p>Principii de bază și angajamentul asumat privind confidențialitatea</p>
                        <p>În cadrul Danone ne-am asumat angajamentul de a vă proteja dreptul la confidențialitate.
                            Obiectivul nostru îl
                            reprezintă protecția tuturor datelor cu caracter personal pe care le deținem, gestionarea
                            datelor
                            dumneavoastră cu caracter personal într-un mod responsabil și asigurarea transparenței în
                            practicile
                            desfășurate. Încrederea dumneavoastră este importantă pentru noi. În acest sens, ne-am asumat
                            respectarea
                            următoarelor principii de bază:</p>
                        <ul>
                            <li>nu aveți obligația de a ne furniza date cu caracter personal solicitate de către noi. Cu
                                toate acestea,
                                în cazul în care optați pentru a nu ni le transmite, există posibilitatea ca noi să nu vă
                                putem oferi
                                anumite servicii sau produse;
                            </li>
                            <li>colectarea și prelucrarea datelor dumneavoastră se face în baza scopurilor exclusive
                                definite în
                                prezenta Declarație priind confidențialitatea sau a celor specifice pe care vi le transmitem
                                și/sau
                                pentru care v-ați exprimat consimțământul;
                            </li>
                            <li>obiectivul nostru îl reprezintă colectarea, prelucrarea și utilizarea unui volum cât mai
                                redus posibil
                                de date cu caracter personal;
                            </li>
                            <li>în cazul în care datele dumneavoastră cu caracter personal sunt colectate în practică,
                                intenționăm să le
                                păstrăm cât mai exacte și actuale posibil.
                            </li>
                            <li>în cazul în care datele dumneavoastră cu caracter personal pe care le colectăm nu mai sunt
                                necesare în
                                scopurile prevăzute și nu ni se impune obligația legală de a le păstra, vom aplica toate
                                măsurile
                                necesare pentru a le șterge, distruge sau anonimiza permanent.
                            </li>
                            <li>datele dumneavoastră cu caracter personal nu vor fi transmise, vândute, închiriate sau
                                dezvăluite în
                                alte scopuri decât cele prevăzute în prezenta Declarație privind confidențialitatea.
                            </li>
                        </ul>
                        <h3>Ce tip de date cu caracter personal colectăm?</h3>
                        <p>Datele cu caracter personal pe care le colectăm sunt diferite, în funcție de&nbsp; scop, dar și
                            de produsul
                            sau serviciul pe care vi-l oferim.</p>
                        <p>În general, putem colecta în mod direct de la dumneavoastră următoarele date cu caracter
                            personal:</p>
                        <ol>
                            <li>date cu caracter personal de contact, precum nume, adresă de e-mail, adresă de domiciliu și
                                numere de
                                telefon;
                            </li>
                            <li>informații de autentificare cont, precum ID utilizator, nume și parolă utilizator e-mail.
                                Acestea sunt
                                necesare în vederea generării unui cont personal de utilizator într-una din comunitățile
                                noastre din
                                mediul online;
                            </li>
                            <li>mesajele pe care le transmitem reciproc, care pot include informații referitoare la
                                discuțiile avute pe
                                serviciile tip chat, serviciile de asistență și/sau servicii asistență clienți;
                            </li>
                            <li>informații demografice, precum vârsta, sexul și preferințe asociate stilului de viață.
                                Preferințele
                                asociate stilului de viață pot include anumite produse pe care le oferim, precum și
                                interesele
                                dumneavoastră asociate produselor respective;
                            </li>
                            <li>istoricul de navigare, precum paginile accesate, data accesării, locația accesării și adresa
                                IP;
                            </li>
                            <li>informații asociate plăților pentru achizițiile efectuate într-unul din magazinele noastre
                                online.
                                Informațiile asociate plăților se referă, în general, la numele necesar facturării, adresa
                                de facturare
                                și date despre plată, precum detalii despre cardul dumneavoastră de credit sau numărul de
                                cont bancar.
                            </li>
                            <li>informații asociate stării dumneavoastră de sănătate;</li>
                            <li>informații despre alte persoane, precum date cu caracter personal care aparțin membrilor
                                familiei, în
                                cazul în care ni le oferiți în mod direct;
                            </li>
                            <li>profiluri din mediile sociale;</li>
                            <li>în cazul în care aplicați pentru un post în cadrul companiei noastre, vom colecta date
                                suplimentare cu
                                caracter personal, precum istoricul locurilor de muncă, al educației, precum și referințe
                                ale
                                angajatorilor anteriori.
                            </li>
                        </ol>
                        <p>De asemenea, putem colecta date cu caracter personal care vă aparțin, în mod indirect, în cazul
                            în care:</p>
                        <ol>
                            <li>distribuiți conținut pe paginile din mediile sociale, pagini de internet sau aplicații,
                                conținut asociat
                                produselor noastre sau ca răspuns la campaniile noastre promoționale din mediile sociale;
                                sau
                            </li>
                            <li>Citim sau colectăm datele dumneavoastră cu caracter personal citind informațiile colectate
                                de pagini de
                                internet diferite (de exemplu, în cazul în care plasăm o reclamă pe o pagină terță de
                                internet; prin
                                accesarea acelei reclame noi putem primi informații despre dumneavoastră și despre alți
                                vizitatori, în
                                vederea calculării numărului de accesări și succesului reclamei respective).
                            </li>
                        </ol>
                        <h3>De ce colectăm și utilizăm datele dumneavoastră cu caracter personal?</h3>
                        <p>Motivul pentru care colectăm datele dumneavoastră cu caracter personal este de a vă putea oferi
                            cele mai bune
                            experiențe online, dar și un nivel de calitate superioară al serviciilor de asistență clienți.
                            În mod
                            special, putem colecta, deține, utiliza și dezvălui datele dumneavoastră cu caracter personal în
                            următoarele
                            scopuri:</p>
                        <ol>
                            <li>pentru a opera plățile dumneavoastră, în cazul în care achiziționați produsele noastre,
                                pentru a vă
                                putea informa despre statusul comenzii, a răspunde la întrebările și solicitările
                                dumneavoastră și
                                pentru a analiza și gestiona potențialele reclamații;
                            </li>
                            <li>pentru a prelucra și a răspunde întrebărilor dumneavoastră sau pentru a vă contacta și vă
                                transmite
                                răspunsurile și/sau solicitările;
                            </li>
                            <li>pentru a ne dezvolta și îmbunătăți gama noastră de produse, servicii, mijloace de comunicare
                                și
                                funcționalitatea paginilor de internet;
                            </li>
                            <li>pentru a vă transmite informații și pentru a administra procedura de autentificare și/sau
                                abonare la
                                newsletterul nostru sau la alte informări;
                            </li>
                            <li>pentru a gestiona procedurile comerciale obișnuite asociate participării dumneavoastră la
                                concursuri,
                                tombole sau activități promoționale, sau solicitări;
                            </li>
                            <li>pentru a putea autentifica identitatea persoanelor care ne contactează prin telefon,
                                mijloace
                                electronice sau de alt tip;
                            </li>
                            <li>pentru cursuri de formare interne și în scop de asigurare a calității;</li>
                            <li>Pentru a înțelege și evalua interesele, dorințele, necesitățile în schimbare ale clienților,
                                în vederea
                                îmbunătățirii paginii de internet, a produselor sau serviciilor noastre, și/sau dezvoltării
                                de noi
                                produse și servicii;
                            </li>
                            <li>pentru a vă oferi produse și mesaje personalizate, precum și recomandări, în calitate de
                                clienți;
                            </li>
                        </ol>
                        <p>De asemenea, putem avea nevoie de datele dumneavoastră cu caracter personal în vederea
                            respectării
                            obligațiilor legale sau în contextul unei relații contractuale pe care o avem cu
                            dumneavoastră.</p>
                        <p>În cazurile în care colectăm și utilizăm datele dumneavoastră cu caracter personal în scopurile
                            mai sus
                            menționate sau în alte scopuri, avem obligația de a vă informa în acest sens anterior sau la
                            momentul
                            colectării lor.</p>
                        <p>În cazurile necesare, vă vom solicita consimțământul pentru a prelucra datele cu caracter
                            personal. În
                            cazurile în care ne acordați consimțământul pentru activitățile de prelucrare, aveți dreptul de
                            a-l retrage
                            la orice moment.</p>
                        <h3>Drepturile dumneavoastră</h3>
                        <p>În cazul prelucrării datelor cu caracter personal care vă aparțin, dumneavoastră beneficiați de
                            mai multe
                            drepturi pe care le puteți exercita în orice moment. Vă oferim mai jos o prezentare a acestor
                            drepturi,
                            împreună cu impactul pe care îl au asupra dumneavoastră. Vă puteți exercita drepturile prin
                            intermediul
                            paginii noastre de contact:&nbsp;<a
                                href="mailto:callcenter@mediasat.ro">callcenter@mediasat.ro</a></p>
                        <h4>Drept de accesare și corectare date cu caracter personal</h4>
                        <p>Aveți dreptul de a accesa, corecta sau actualiza datele dumneavoastră cu caracter personal la
                            orice moment.
                            Înțelegem importanța acestui lucru și, în cazul în care doriți să vă exercitați drepturile, vă
                            rugăm să ne
                            contactați prin intermediul adresei de email:&nbsp;<a
                                href="mailto:callcenter@mediasat.ro">callcenter@mediasat.ro</a>.
                        </p>
                        <h4>Drept de portabilitate date</h4>
                        <p>Datele dumneavoastră cu caracter personal sunt portabile. Aceasta înseamnă că ele pot fi
                            transferate, copiate
                            sau transmise electronic. Cu toate acestea, dreptul se aplică exclusiv în cazul în care:</p>
                        <ol>
                            <li>a) prelucrarea are la bază consimțământul dumneavoastră;</li>
                            <li>b) prelucrarea are ca scop executarea unui contract;</li>
                            <li>c) prelucrarea se efectuează prin mijloace automate;</li>
                        </ol>
                        <p>În cazul în care doriți să vă exercitați dreptul la portabilitatea datelor, vă rugăm să ne
                            contactați prin
                            intermediul adresei de email:&nbsp;<a
                                href="mailto:callcenter@mediasat.ro">callcenter@mediasat.ro</a>.</p>
                        <h4>Dreptul de ștergere a datelor cu caracter personal</h4>
                        <p>Aveți dreptul de a solicita ștergerea datelor dumneavoastră, în cazul în care:</p>
                        <ol>
                            <li>datele dumneavoastră cu caracter personal nu mai sunt necesare în scopurile pentru care au
                                fost
                                colectate; sau
                            </li>
                            <li>vă retrageți consimțământul acordat anterior în vederea prelucrării datelor dumneavoastră cu
                                caracter
                                personal, nemaiexistând un temei legal în acest sens; sau
                            </li>
                            <li>refuzați prelucrarea datelor dumneavoastră cu caracter personal în scop de marketing direct;
                                sau
                            </li>
                            <li>refuzați prelucrarea datelor dumneavoastră cu caracter personal în interese legitime ale
                                Danone (precum
                                îmbunătățirea generală a experienței utilizatorului pe paginile noastre de internet);
                            </li>
                            <li>datele cu caracter personal nu sunt prelucrate legitim; sau</li>
                            <li>datele dumneavoastră cu caracter personal trebuie șterse în baza unei obligații legale.</li>
                        </ol>
                        <p>În cazul în care doriți ștergerea datelor cu caracter personal pe care le deținem și care vă
                            aparțin, vă
                            rugăm să ne comunicați printr-un e-mail la&nbsp;<a
                                href="mailto:callcenter@mediasat.ro">callcenter@mediasat.ro</a>,
                            urmând ca noi să aplicăm măsuri rezonabile pentru a vă răspunde la solicitare, în conformitate
                            cu normele
                            legale.</p>
                        <p>În cazul în care datele dumneavoastră cu caracter personal pe care le colectăm nu mai sunt
                            necesare în
                            scopurile prevăzute și nu ni se impune obligația legală de a le păstra, vom aplica toate
                            măsurile necesare
                            pentru a le șterge, distruge sau anonimiza permanent.</p>
                        <h4>Drept de restricționare prelucrare</h4>
                        <p>Aveți dreptul de a restricționa prelucrarea datelor dumneavoastră cu caracter personal în cazul
                            în care</p>
                        <ol>
                            <li>nu aveți convingerea că datele cu caracter personal pe care le deținem despre dumneavoastră
                                sunt exacte;
                                sau
                            </li>
                            <li>datele cu caracter personal nu sunt legal prelucrate, și, în locul ștergerii lor, preferați
                                să
                                restricționăm prelucrarea; sau
                            </li>
                            <li>nu ne mai sunt necesare datele dumneavoastră cu caracter personal în scopurile colectării
                                lor, dar le
                                solicitați în vederea înaintării, exercitării sau apărării împotriva unei acțiuni în
                                justiție; sau
                            </li>
                            <li>v-ați exprimat refuzul privind prelucrarea datelor dumneavoastră cu caracter personal, dar
                                noi așteptăm
                                confirmarea dacă interesele asociate refuzului le depășesc pe cele legitime referitoare la
                                prelucrarea
                                datelor dumneavoastră.
                            </li>
                        </ol>
                        <p>În cazul în care doriți restricționarea prelucrării datelor cu caracter personal care vă aparțin,
                            vă rugăm să
                            ne comunicați printr-un e-mail la adresa&nbsp;<a
                                href="mailto:callcenter@mediasat.ro">callcenter@mediasat.ro</a>, urmând ca noi să aplicăm
                            măsuri
                            rezonabile pentru a vă răspunde la solicitare, în conformitate cu normele legale.</p>
                        <h4>Drept de refuzare</h4>
                        <p>Aveți dreptul de a refuza prelucrarea datelor dumneavoastră cu caracter personal la orice moment.
                            Vă rugăm să
                            ne contactați printr-un email la adresa:&nbsp;<a
                                href="mailto:callcenter@mediasat.ro">callcenter@mediasat.ro</a>.</p>
                        <p>Drept de a depune o reclamație la o autoritate de supraveghere</p>
                        <p>Aveți dreptul de a depune în mod direct la autoritatea de supraveghere o reclamație referitoare
                            la modul de
                            prelucrare a datelor cu caracter personal.</p>
                        <p>Cum protejăm datele dumneavoastră cu caracter personal</p>
                        <p>Înțelegem faptul că securitatea datelor dumneavoastră cu caracter personal este importantă.
                            Depunem toate
                            eforturile pentru a proteja datele dumneavoastră cu caracter personal împotriva utilizării
                            necorespunzătoare, a interferenței, pierderii, accesării neautorizate, modificării sau
                            dezvăluirii. Am
                            implementat mai multe măsuri de securitate pentru a contribui la protecția datelor dumneavoastră
                            cu caracter
                            personal. De exemplu, implementăm instrumente de control acces, sisteme firewall și servere
                            sigure, cu
                            criptarea datelor cu caracter personal.</p>
                        <h4>Transmiterea datelor dumneavoastră cu caracter personal</h4>
                        <p>În cazul în care transmitem datele dumneavoastră cu caracter personal afiliaților sau altor
                            organizații, ne
                            asigurăm că procedăm astfel exclusiv în relația cu organizații care protejează și garantează
                            acest tip de
                            date, cu respectarea legislației cu privire la confidențialitate în vigoare în mod similar sau
                            asemănător
                            procedurilor proprii.</p>
                        <p>Datele dumneavoastră cu caracter personal nu vor fi transmise, vândute, închiriate sau dezvăluite
                            în alte
                            scopuri decât cele prevăzute în prezenta Declarație privind confidențialitatea. Cu toate
                            acestea, există
                            posibilitatea de a transmite datele dumneavoastră la solicitarea autorităților legale și/sau
                            guvernamentale.</p>
                        <h4>Transfer internațional de date</h4>
                        <p>Datele cu caracter personal pot fi prelucrate în afara Spațiului Economic European (EEA). În
                            cazul
                            prelucrării în afara EEA, Danone va garanta că acest tip de prelucrare de date transfrontalieră
                            este
                            protejată prin măsuri corespunzătoare.</p>
                        <p>Măsurile aplicate de protecție a prelucrării de date transfrontaliere includ:</p>
                        <ol>
                            <li>Clauze contractuale standard autorizate de Comisia Europeană. Aceste clauze contractuale
                                standard
                                asigură măsuri de protecție suficiente pentru respectarea normelor de conformitate și
                                securitate
                                prevăzute de Regulament European General privind Protecția Datelor; sau
                            </li>
                            <li>Certificări prin care se atestă că terțele părți din afara EEA prelucrează datele cu
                                caracter personal
                                prin metode conforme cu Regulamentul European General privind Protecția Datelor. Aceste
                                certificări sunt
                                autorizate fie de către Comisia Europeană, o autoritate de supraveghere competentă sau un
                                organism
                                național competent de acreditare, în termenii Regulamentului General de Protecție a Datelor.
                            </li>
                        </ol>
                        <h4>Procese automate de luare a deciziilor și analiză de profil</h4>
                        <p>În cazul anumitor servicii și produse, putem prelucra datele dumneavoastră cu caracter personal
                            prin mijloace
                            automate. În esență, aceasta înseamnă că deciziile se iau automat, fără intervenție umană.</p>
                        <p>De asemenea, putem prelucra datele dumneavoastră cu caracter personal în scopuri de analiză de
                            profil, pentru
                            a putea estima comportamentul dumneavoastră în cazul paginii noastre de internet sau produselor
                            pentru care
                            vă puteți manifesta interesele.</p>
                        <p>În cazul în care intenționăm să aplicăm aceste metode, vă vom informa cu siguranță în acest sens,
                            oferindu-vă
                            oportunitatea de a vă exprima refuzul în avans. De asemenea, ne puteți contacta la&nbsp;<a
                                href="mailto:callcenter@mediasat.ro">callcenter@mediasat.ro</a>&nbsp;pentru mai multe
                            informații cu
                            privire la un astfel de tip de prelucrare.</p>
                        <h3>Cookies și alte tehnologii</h3>
                        <p>De asemenea, putem colecta date cu caracter personal despre dumneavoastră prin intermediul
                            utilizării cookies
                            și a altor tehnologii. Acest lucru se poate întâmpla atunci când vizitați paginile proprii sau
                            ale terților,
                            vizualizați promoțiile online, sau utilizați aplicații mobile proprii/ale terților și și care
                            pot include
                            următoarele informații:</p>
                        <ol>
                            <li>a) informații despre browser dispozitiv și sistem de operare;</li>
                            <li>b) adresă IP a dispozitivului utilizat;</li>
                            <li>c) pagini de internet proprii pe care le vizualizați;</li>
                            <li>d) link-uri pe care le accesați la interacțiunea cu serviciile proprii.</li>
                        </ol>
                        <p>Vă rugăm să citiți&nbsp;<a style={{color: '#008fc5'}} href="http://www.danone.ro/politica-cookies/">declarația
                            noastră cu privire la cookies</a>&nbsp;pentru mai multe informații.</p>
                        <h3>Informații de contact</h3>
                        <p>În cazul în care aveți întrebări, observații sau reclamații cu privire la prezenta Declarație
                            privind
                            confidențialitatea prelucrării datelor dumneavoastră cu caracter personal, vă rugăm să ne
                            contactați prin
                            intermediul adresei de email:&nbsp;<a
                                href="mailto:callcenter@mediasat.ro">callcenter@mediasat.ro</a>.</p>

                        <p>&nbsp;</p>
                    </div>

                    <div className="bottom-content">

                    </div>

                </div>
            </div>
        </Typography>
    </Grid>

}

export default PagePoliticaDeConfidentialitate;
